(function () {
  'use strict';

  if (window.BizDecksInsideToolkitFlowLoaded) return;
  window.BizDecksInsideToolkitFlowLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function parseExamples(root) {
    var data = root.querySelector('[data-bd-rtf-examples]');
    if (!data) return [];
    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      console.error('BizDecks Inside Toolkit example data is invalid.', error);
      return [];
    }
  }

  function initSection(root) {
    if (!root || root.dataset.bdRtfReady === 'true') return;
    root.dataset.bdRtfReady = 'true';

    var examples = parseExamples(root);
    var grouped = {};
    examples.forEach(function (example) {
      if (!example.itemKey || !example.src) return;
      if (!grouped[example.itemKey]) grouped[example.itemKey] = [];
      if (grouped[example.itemKey].length < 5) grouped[example.itemKey].push(example);
    });

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bd-rtf-flow-item]'));
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-bd-rtf-example-trigger]'));
    var galleries = Array.prototype.slice.call(root.querySelectorAll('[data-bd-rtf-flow-gallery]'));
    var stage = root.querySelector('.bd-rtf-flow-stage');
    var mobileCount = root.querySelector('[data-bd-rtf-mobile-count]');
    var mobilePrev = root.querySelector('[data-bd-rtf-mobile-prev]');
    var mobileNext = root.querySelector('[data-bd-rtf-mobile-next]');
    var modal = root.querySelector('[data-bd-rtf-modal]');
    var dialog = modal && modal.querySelector('.bd-rtf-modal__dialog');
    var modalTitle = modal && modal.querySelector('[data-bd-rtf-modal-title]');
    var modalImage = modal && modal.querySelector('[data-bd-rtf-modal-image]');
    var modalViewport = modal && modal.querySelector('[data-bd-rtf-modal-viewport]');
    var modalTrack = modal && modal.querySelector('[data-bd-rtf-modal-track]');
    var modalBadge = modal && modal.querySelector('[data-bd-rtf-modal-badge]');
    var modalCaption = modal && modal.querySelector('[data-bd-rtf-modal-caption]');
    var modalLink = modal && modal.querySelector('[data-bd-rtf-modal-link]');
    var modalCount = modal && modal.querySelector('[data-bd-rtf-modal-count]');
    var modalPrev = modal && modal.querySelector('[data-bd-rtf-modal-prev]');
    var modalNext = modal && modal.querySelector('[data-bd-rtf-modal-next]');
    var modalDots = modal && modal.querySelector('[data-bd-rtf-modal-dots]');
    var modalMedia = modal && modal.querySelector('.bd-rtf-modal__media');
    var activeExamples = [];
    var activeIndex = 0;
    var opener = null;
    var bodyOverflow = '';
    var inertedElements = [];
    var modalTitleSuffix = root.dataset.modalTitleSuffix || 'examples';
    var modalDefaultTitle = root.dataset.modalDefaultTitle || 'Toolkit examples';
    var popupDesktopEnabled = root.dataset.enableFlowPopupDesktop === 'true';
    var popupMobileEnabled = root.dataset.enableFlowPopupMobile === 'true';
    var modalRequest = 0;
    var modalAnimating = false;
    var modalAnimationTimer = 0;
    var modalAnimationFinish = null;
    var modalPreloads = new Map();
    var modalSwipe = { id: null, startX: 0, startY: 0, lastX: 0, lastTime: 0, velocityX: 0, deltaX: 0, dragging: false, frame: 0 };
    var resetModalSwipe = null;

    function popupAllowed() {
      return mobileQuery.matches ? popupMobileEnabled : popupDesktopEnabled;
    }

    function setBackgroundInert(enabled) {
      if (!enabled) {
        inertedElements.forEach(function (element) { element.inert = false; });
        inertedElements = [];
        return;
      }
      inertedElements = [];
      var branch = modal;
      while (branch && branch !== document.body) {
        var parent = branch.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (element) {
          if (element === branch || element.inert) return;
          element.inert = true;
          inertedElements.push(element);
        });
        branch = parent;
      }
    }

    function visibleItems() {
      return items.filter(function (item) { return item.getClientRects().length > 0; });
    }

    function setInteractionMode() {
      triggers.forEach(function (trigger) {
        var hasExamples = (grouped[trigger.dataset.itemKey] || []).length > 0;
        var enabled = hasExamples && popupAllowed() && !!modal;
        trigger.disabled = !enabled;
        if (enabled) {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', modal.id);
          trigger.removeAttribute('aria-disabled');
        } else {
          trigger.removeAttribute('aria-haspopup');
          trigger.removeAttribute('aria-controls');
          trigger.setAttribute('aria-disabled', 'true');
        }
      });
      galleries.forEach(function (gallery) {
        var trigger = gallery.querySelector('[data-bd-rtf-example-trigger]');
        gallery.classList.toggle('is-popup-enabled', !!trigger && !trigger.disabled);
      });
    }

    function buildDots() {
      if (!modalDots) return;
      modalDots.replaceChildren();
      var multiple = activeExamples.length > 1;
      modalDots.hidden = !multiple;
      if (!multiple) return;
      activeExamples.forEach(function (_example, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bd-rtf-modal__dot';
        dot.dataset.bdRtfModalDot = String(index);
        dot.setAttribute('aria-label', 'Example ' + (index + 1) + ' of ' + activeExamples.length);
        dot.addEventListener('click', function () { goToExample(index); });
        modalDots.appendChild(dot);
      });
    }

    function modalModulo(index) {
      if (!activeExamples.length) return 0;
      return ((index % activeExamples.length) + activeExamples.length) % activeExamples.length;
    }

    function modalSizes() {
      return '(max-width: 749px) calc(100vw - 60px), 820px';
    }

    function modalSrcset(example) {
      var candidates = mobileQuery.matches
        ? [[example.srcSmall, 480], [example.srcMedium, 720], [example.src, 960]]
        : [[example.srcMedium, 720], [example.src, 960], [example.srcWide, 1200]];
      return candidates.filter(function (candidate, index, all) {
        return candidate[0] && all.findIndex(function (other) { return other[0] === candidate[0]; }) === index;
      }).map(function (candidate) { return candidate[0] + ' ' + candidate[1] + 'w'; }).join(', ');
    }

    function setModalImage(image, example, current) {
      if (!image) return;
      if (!example) {
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.removeAttribute('fetchpriority');
        image.alt = '';
        return;
      }
      var sources = modalSrcset(example);
      image.decoding = 'async';
      image.loading = 'eager';
      image.draggable = false;
      if (sources) {
        image.sizes = modalSizes();
        image.srcset = sources;
      }
      image.setAttribute('fetchpriority', current ? 'high' : 'low');
      image.src = example.src;
      image.alt = current ? (example.alt || example.caption || modalTitle.textContent) : '';
    }

    function modalCanWarm() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!connection) return true;
      if (connection.saveData) return false;
      return connection.effectiveType !== 'slow-2g' && connection.effectiveType !== '2g';
    }

    function prepareExample(example) {
      if (!example) return Promise.resolve();
      var key = (mobileQuery.matches ? 'mobile:' : 'desktop:') + example.src;
      if (modalPreloads.has(key)) return modalPreloads.get(key);
      var promise = new Promise(function (resolve) {
        var image = new Image();
        var settled = false;
        image.decoding = 'async';
        image.loading = 'eager';
        image.fetchPriority = 'low';
        image.sizes = modalSizes();
        image.srcset = modalSrcset(example);
        var done = function () {
          if (settled) return;
          settled = true;
          if (typeof image.decode === 'function') image.decode().catch(function () {}).then(resolve);
          else resolve();
        };
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
        image.src = example.src;
        if (image.complete) done();
      });
      modalPreloads.set(key, promise);
      return promise;
    }

    function renderModalSlots(warmNeighbors, resetTrack) {
      if (!modalTrack || !activeExamples.length) return;
      Array.prototype.forEach.call(modalTrack.querySelectorAll('[data-bd-rtf-modal-slot]'), function (slot) {
        var name = slot.dataset.bdRtfModalSlot;
        var offset = name === 'previous' ? -1 : (name === 'next' ? 1 : 0);
        var image = slot.querySelector('[data-bd-rtf-modal-slot-image]');
        if (offset === 0 || warmNeighbors) setModalImage(image, activeExamples[modalModulo(activeIndex + offset)], offset === 0);
        else setModalImage(image, null, false);
        slot.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
      });
      if (resetTrack !== false) {
        modalTrack.style.transition = 'none';
        modalTrack.style.transform = 'translate3d(-100%, 0, 0)';
      }
    }

    function cancelModalAnimation(resetTrack) {
      if (modalAnimationFinish && modalTrack) modalTrack.removeEventListener('transitionend', modalAnimationFinish);
      if (modalAnimationTimer) window.clearTimeout(modalAnimationTimer);
      modalAnimationFinish = null;
      modalAnimationTimer = 0;
      modalAnimating = false;
      if (resetTrack && modalTrack) {
        modalTrack.style.transition = 'none';
        modalTrack.style.transform = 'translate3d(-100%, 0, 0)';
      }
    }

    function updateExampleCopy(announce) {
      var example = activeExamples[activeIndex];
      modalCaption.textContent = example.caption || '';
      modalCaption.hidden = !example.caption;
      modalBadge.textContent = example.badge || '';
      modalBadge.hidden = !example.badge;
      modalBadge.classList.toggle('bd-rtf-hidden-desktop', example.badgeShowDesktop === false);
      modalBadge.classList.toggle('bd-rtf-hidden-mobile', example.badgeShowMobile === false);
      modalLink.href = example.link || '';
      modalLink.textContent = example.linkLabel || 'Learn more';
      modalLink.hidden = !example.link;
      var multiple = activeExamples.length > 1;
      modalPrev.hidden = !multiple;
      modalNext.hidden = !multiple;
      modalCount.textContent = multiple ? (activeIndex + 1) + ' of ' + activeExamples.length : '';
      if (!announce) modalCount.setAttribute('aria-live', 'off');
      else modalCount.setAttribute('aria-live', 'polite');
      if (modalDots) {
        Array.prototype.forEach.call(modalDots.querySelectorAll('[data-bd-rtf-modal-dot]'), function (dot, dotIndex) {
          var active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    function warmModalNeighbors(token) {
      if (!modalCanWarm() || token !== modalRequest || modal.hidden) return;
      var previous = activeExamples[modalModulo(activeIndex - 1)];
      var next = activeExamples[modalModulo(activeIndex + 1)];
      Promise.all([prepareExample(previous), prepareExample(next)]).then(function () {
        if (token !== modalRequest || modal.hidden) return;
        renderModalSlots(true, false);
      });
    }

    function commitExample(index, announce, warmNeighbors) {
      if (!activeExamples.length) return;
      activeIndex = modalModulo(index);
      renderModalSlots(!!warmNeighbors);
      updateExampleCopy(announce);
      if (modalMedia) modalMedia.classList.remove('is-loading');
    }

    function renderExample(index) {
      if (!activeExamples.length) return;
      cancelModalAnimation(true);
      modalRequest += 1;
      var token = modalRequest;
      commitExample(index, false, false);
      if (modalMedia) modalMedia.classList.add('is-loading');
      warmModalNeighbors(token);
      var ready = modalImage && typeof modalImage.decode === 'function'
        ? modalImage.decode().catch(function () {})
        : prepareExample(activeExamples[activeIndex]);
      ready.then(function () {
        if (token !== modalRequest || modal.hidden) return;
        if (modalMedia) modalMedia.classList.remove('is-loading');
      });
    }

    function animateExampleStep(direction, fromDrag) {
      if (activeExamples.length < 2 || modalAnimating) return;
      var targetIndex = modalModulo(activeIndex + direction);
      var target = activeExamples[targetIndex];
      modalRequest += 1;
      var token = modalRequest;
      modalAnimating = true;
      renderModalSlots(true, !fromDrag);
      prepareExample(target);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var done = false;
      var finish = function (event) {
        if (event && event.target !== modalTrack) return;
        if (done) return;
        done = true;
        modalTrack.removeEventListener('transitionend', finish);
        if (modalAnimationTimer) window.clearTimeout(modalAnimationTimer);
        modalAnimationTimer = 0;
        modalAnimationFinish = null;
        if (token !== modalRequest || modal.hidden) return;
        modalAnimating = false;
        commitExample(targetIndex, true, true);
        warmModalNeighbors(token);
      };
      modalAnimationFinish = finish;
      modalTrack.addEventListener('transitionend', finish);
      modalTrack.style.transition = reduced ? 'none' : 'transform 230ms cubic-bezier(0.22, 0.8, 0.25, 1)';
      window.requestAnimationFrame(function () {
        if (token !== modalRequest || modal.hidden || !modalAnimating) return;
        modalTrack.style.transform = direction > 0 ? 'translate3d(-200%, 0, 0)' : 'translate3d(0%, 0, 0)';
        if (reduced) finish();
        else modalAnimationTimer = window.setTimeout(finish, 310);
      });
    }

    function goToExample(index) {
      if (modalAnimating) return;
      var targetIndex = modalModulo(index);
      if (targetIndex === activeIndex) return;
      if (targetIndex === modalModulo(activeIndex + 1)) {
        animateExampleStep(1);
        return;
      }
      if (targetIndex === modalModulo(activeIndex - 1)) {
        animateExampleStep(-1);
        return;
      }
      modalRequest += 1;
      var token = modalRequest;
      modalAnimating = true;
      if (modalMedia) modalMedia.classList.add('is-loading');
      prepareExample(activeExamples[targetIndex]).then(function () {
        if (token !== modalRequest || modal.hidden) return;
        modalAnimating = false;
        commitExample(targetIndex, true, false);
        warmModalNeighbors(token);
      });
    }

    function openModal(trigger, requestedIndex) {
      if (!popupAllowed() || !modal) return;
      modalRequest += 1;
      cancelModalAnimation(true);
      if (resetModalSwipe) resetModalSwipe(false);
      activeExamples = grouped[trigger.dataset.itemKey] || [];
      if (!activeExamples.length) return;
      var heading = trigger.dataset.modalTitle || '';
      modalTitle.textContent = heading ? heading + ' ' + modalTitleSuffix : modalDefaultTitle;
      opener = trigger;
      bodyOverflow = document.body.style.overflow;
      buildDots();
      modal.hidden = false;
      setBackgroundInert(true);
      document.body.style.overflow = 'hidden';
      renderExample(Number.isFinite(requestedIndex) ? requestedIndex : 0);
      window.requestAnimationFrame(function () { dialog.focus(); });
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modalRequest += 1;
      cancelModalAnimation(true);
      if (resetModalSwipe) resetModalSwipe(false);
      if (modalMedia) modalMedia.classList.remove('is-loading');
      modal.hidden = true;
      setBackgroundInert(false);
      document.body.style.overflow = bodyOverflow;
      if (opener && typeof opener.focus === 'function') opener.focus();
      opener = null;
    }

    function currentMobileIndex() {
      var visible = visibleItems();
      if (!visible.length || !stage) return 0;
      var stageCenter = stage.getBoundingClientRect().left + stage.clientWidth / 2;
      var best = 0;
      var distance = Infinity;
      visible.forEach(function (item, index) {
        var rect = item.getBoundingClientRect();
        var nextDistance = Math.abs(rect.left + rect.width / 2 - stageCenter);
        if (nextDistance < distance) {
          distance = nextDistance;
          best = index;
        }
      });
      return best;
    }

    function updateMobileControls() {
      var visible = visibleItems();
      var index = currentMobileIndex();
      if (mobileCount) mobileCount.textContent = visible.length ? (index + 1) + ' of ' + visible.length : '';
      if (mobilePrev) mobilePrev.disabled = index <= 0;
      if (mobileNext) mobileNext.disabled = index >= visible.length - 1;
    }

    function scrollToMobileItem(index) {
      var visible = visibleItems();
      var item = visible[Math.max(0, Math.min(index, visible.length - 1))];
      if (!item || !stage) return;
      var left = item.getBoundingClientRect().left - stage.getBoundingClientRect().left + stage.scrollLeft;
      stage.scrollTo({ left: left, behavior: 'smooth' });
    }

    function currentGalleryIndex(gallery) {
      var carousel = gallery && gallery.querySelector('bd-media-carousel');
      return carousel && Number.isFinite(carousel.activeIndex) ? carousel.activeIndex : 0;
    }

    function isGalleryControl(target) {
      return !!(target && target.closest('[data-bd-carousel-previous], [data-bd-carousel-next], [data-bd-carousel-dot], [data-bd-rtf-example-trigger], [data-bd-rtf-modal-prev], [data-bd-rtf-modal-next], [data-bd-rtf-modal-close], [data-bd-rtf-modal-dot], a[href]'));
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger, currentGalleryIndex(trigger.closest('[data-bd-rtf-flow-gallery]')));
      });
    });

    galleries.forEach(function (gallery) {
      var pointerStart = null;
      gallery.addEventListener('pointerdown', function (event) {
        if (isGalleryControl(event.target)) {
          pointerStart = null;
          return;
        }
        pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true });
      gallery.addEventListener('pointerup', function (event) {
        if (!pointerStart || pointerStart.id !== event.pointerId || isGalleryControl(event.target)) {
          pointerStart = null;
          return;
        }
        var distanceX = Math.abs(event.clientX - pointerStart.x);
        var distanceY = Math.abs(event.clientY - pointerStart.y);
        pointerStart = null;
        if (distanceX > 8 || distanceY > 8) return;
        var trigger = gallery.querySelector('[data-bd-rtf-example-trigger]');
        if (trigger && !trigger.disabled) openModal(trigger, currentGalleryIndex(gallery));
      });
      gallery.addEventListener('pointercancel', function () { pointerStart = null; });
    });

    root.addEventListener('shopify:block:select', function (event) {
      var selectedFlow = event.target && event.target.closest('[data-bd-rtf-flow-item]');
      var selectedTrigger = selectedFlow && selectedFlow.querySelector('[data-bd-rtf-example-trigger]');
      if (selectedTrigger) {
        if (popupAllowed()) openModal(selectedTrigger, currentGalleryIndex(selectedFlow));
        else selectedTrigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });

    if (mobilePrev) mobilePrev.addEventListener('click', function () { scrollToMobileItem(currentMobileIndex() - 1); });
    if (mobileNext) mobileNext.addEventListener('click', function () { scrollToMobileItem(currentMobileIndex() + 1); });
    if (stage) stage.addEventListener('scroll', updateMobileControls, { passive: true });

    if (modal) {
      modal.querySelector('[data-bd-rtf-modal-close]').addEventListener('click', closeModal);
      modal.querySelector('[data-bd-rtf-modal-overlay]').addEventListener('click', closeModal);
      modalPrev.addEventListener('click', function () { animateExampleStep(-1, false); });
      modalNext.addEventListener('click', function () { animateExampleStep(1, false); });
      if (modalViewport && modalTrack) {
        var paintModalSwipe = function () {
          modalSwipe.frame = 0;
          if (!modalSwipe.dragging) return;
          modalTrack.style.transform = 'translate3d(calc(-100% + ' + modalSwipe.deltaX + 'px), 0, 0)';
        };
        resetModalSwipe = function (snapBack) {
          if (modalSwipe.frame) window.cancelAnimationFrame(modalSwipe.frame);
          if (snapBack) {
            modalTrack.style.transition = 'transform 170ms cubic-bezier(0.22, 0.8, 0.25, 1)';
            modalTrack.style.transform = 'translate3d(-100%, 0, 0)';
          }
          var pointerId = modalSwipe.id;
          modalSwipe.id = null;
          modalSwipe.startX = 0;
          modalSwipe.startY = 0;
          modalSwipe.lastX = 0;
          modalSwipe.lastTime = 0;
          modalSwipe.velocityX = 0;
          modalSwipe.deltaX = 0;
          modalSwipe.dragging = false;
          modalSwipe.frame = 0;
          if (pointerId !== null && modalViewport.hasPointerCapture && modalViewport.hasPointerCapture(pointerId)) {
            try { modalViewport.releasePointerCapture(pointerId); } catch (error) { /* Pointer capture is optional. */ }
          }
        };
        modalViewport.addEventListener('pointerdown', function (event) {
          if (!event.isPrimary || event.button > 0 || activeExamples.length < 2 || modalAnimating) return;
          renderModalSlots(true);
          prepareExample(activeExamples[modalModulo(activeIndex - 1)]);
          prepareExample(activeExamples[modalModulo(activeIndex + 1)]);
          modalSwipe.id = event.pointerId;
          modalSwipe.startX = event.clientX;
          modalSwipe.startY = event.clientY;
          modalSwipe.lastX = event.clientX;
          modalSwipe.lastTime = event.timeStamp || performance.now();
          modalSwipe.velocityX = 0;
          modalSwipe.deltaX = 0;
          modalSwipe.dragging = false;
          if (modalViewport.setPointerCapture) {
            try { modalViewport.setPointerCapture(event.pointerId); } catch (error) { /* Pointer capture is optional. */ }
          }
        });
        modalViewport.addEventListener('pointermove', function (event) {
          if (modalSwipe.id !== event.pointerId) return;
          var deltaX = event.clientX - modalSwipe.startX;
          var deltaY = event.clientY - modalSwipe.startY;
          if (!modalSwipe.dragging) {
            if (Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return;
            if (Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) {
              resetModalSwipe(false);
              return;
            }
            modalSwipe.dragging = true;
            modalTrack.style.transition = 'none';
          }
          event.preventDefault();
          var now = event.timeStamp || performance.now();
          var elapsed = Math.max(1, now - modalSwipe.lastTime);
          modalSwipe.velocityX = (event.clientX - modalSwipe.lastX) / elapsed;
          modalSwipe.lastX = event.clientX;
          modalSwipe.lastTime = now;
          modalSwipe.deltaX = deltaX;
          if (!modalSwipe.frame) modalSwipe.frame = window.requestAnimationFrame(paintModalSwipe);
        });
        modalViewport.addEventListener('pointerup', function (event) {
          if (modalSwipe.id !== event.pointerId) return;
          var deltaX = event.clientX - modalSwipe.startX;
          var deltaY = event.clientY - modalSwipe.startY;
          var threshold = Math.min(82, Math.max(42, modalViewport.clientWidth * 0.15));
          var commit = modalSwipe.dragging && Math.abs(deltaX) > Math.abs(deltaY) * 1.15 && (Math.abs(deltaX) >= threshold || Math.abs(modalSwipe.velocityX) >= 0.48);
          var direction = deltaX < 0 ? 1 : -1;
          resetModalSwipe(!commit);
          if (commit) animateExampleStep(direction, true);
        });
        modalViewport.addEventListener('pointercancel', function (event) {
          if (modalSwipe.id === event.pointerId) resetModalSwipe(true);
        });
        modalViewport.addEventListener('lostpointercapture', function (event) {
          if (event.target !== modalViewport || modalSwipe.id !== event.pointerId) return;
          resetModalSwipe(true);
        });
      }
      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }
        if (event.key === 'ArrowLeft' && activeExamples.length > 1) {
          event.preventDefault();
          animateExampleStep(-1, false);
          return;
        }
        if (event.key === 'ArrowRight' && activeExamples.length > 1) {
          event.preventDefault();
          animateExampleStep(1, false);
          return;
        }
        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.filter.call(dialog.querySelectorAll(focusableSelector), function (element) {
          return !element.disabled && !element.hidden && element.getClientRects().length > 0;
        });
        if (!focusable.length) {
          event.preventDefault();
          dialog.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    function handleBreakpoint() {
      if (!popupAllowed()) closeModal();
      setInteractionMode();
      updateMobileControls();
    }

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', handleBreakpoint);
    else mobileQuery.addListener(handleBreakpoint);
    window.addEventListener('resize', updateMobileControls, { passive: true });
    setInteractionMode();
    updateMobileControls();
    var delayedMobileUpdate = window.setTimeout(updateMobileControls, 180);
    root.bdRtfDestroy = function () {
      closeModal();
      window.clearTimeout(delayedMobileUpdate);
      window.removeEventListener('resize', updateMobileControls);
      if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', handleBreakpoint);
      else mobileQuery.removeListener(handleBreakpoint);
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bd-rtf]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-bd-rtf]');
    if (root && typeof root.bdRtfDestroy === 'function') root.bdRtfDestroy();
  });
})();
